export default "__VITE_ASSET__DRhBv72C__"